<template>
  <div>
    <div class="font-display text-4xl sm:text-5xl font-semibold text-white tracking-tight">{{ value }}</div>
    <div class="mt-2 text-sm text-ink-300">{{ label }}</div>
    <div v-if="note" class="text-2xs text-ink-500 font-mono mt-1">{{ note }}</div>
  </div>
</template>

<script setup>
defineProps({
  value: { type: String, required: true },
  label: { type: String, required: true },
  note:  { type: String, default: '' },
});
</script>
